import { useNavSections } from '../../hooks/useNavSections';
import NavTab from './NavTab';
import PlatformMenu from './PlatformMenu';

export default function NavTabs() {
    const sections = useNavSections();
    return (
        <nav className="nav-tabs" aria-label="Primary">
            {sections.map((section) => {
                if (section.kind === 'dropdown' && section.variant === 'platform') {
                    return <PlatformMenu key={section.id} section={section} />;
                }
                return <NavTab key={section.id} section={section} />;
            })}
        </nav>
    );
}
